import { combineReducers } from "redux";
import {
    SET_DAY_RANGE,
    SET_SELECTED_DAYS,
    SET_TRACKS,
    SET_TRACK_ROW,
    OPEN_ADD_EVENT_MODAL,
    CLOSE_ADD_EVENT_MODAL,
    OPEN_EDIT_EVENT_MODAL,
    CLOSE_EDIT_EVENT_MODAL,
    OPEN_DELETE_TRACK_MODAL,
    CLOSE_DELETE_TRACK_MODAL,
    OPEN_ADD_PARENT_TRACK_MODAL,
    CLOSE_ADD_PARENT_TRACK_MODAL,
    OPEN_ADD_CHILD_TRACK_MODAL,
    CLOSE_ADD_CHILD_TRACK_MODAL,
    CREATE_PARENT_TRACK,
    DELETE_TRACK,
    SET_DELETING_TRACK,
    SET_CREATE_CHILD_TRACK_PARENT,
    CREATE_CHILD_TRACK,
    OPEN_EDIT_TRACK_MODAL,
    CLOSE_EDIT_TRACK_MODAL,
    SET_EDITING_TRACK,
    EDIT_TRACK,
    GET_JOB_PACKS,
    GET_MACHINES,
    GET_USERS,
    GET_EQUIPMENT,
    SET_FOCUSSED_EVENT,
    SET_FOCUSSED_EVENT_INDICES,
    SET_CLICKED_TIME_BLOCK,
    SET_AGENDA_ITEM_DRAGGING,
    SET_AGENDA_ITEM_POSITION,
    SET_WEEK_COUNT,
    SET_TRACK_HEIGHT,
    SET_UI_STATE,
    GET_UI_STATE,
    SET_PARENT_TRACK_OPEN
} from "./types";
const INITIAL_STATE = {
    eventRow: false,
    taskRow: false,
    start: false,
    end: false,
    selectedDays: false,
    tracks: false,
    showAddEventModal: false,
    showEditEventModal: false,
    showAddParentTrackModal: false,
    showAddChildTrackModal: false,
    showDeleteTrackModal: false,
    showEditTrackModal: false,
    deletingTrack: false,
    createChildTrackParent: false,
    clickedTimeBlock: false,
    clickedDayTimeBlock: false,
    editingTrack: false,
    jobpacks: false,
    users: false,
    machines: false,
    equipment: false,
    focussedEvent: false,
    focussedEventHasFocus: false,
    focussedEventIndices: false,
    agendaItemDragging: false,
    agendaItemPosition: false,
    weekCount: 2,
    uiState: false
};

const MainReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_PARENT_TRACK_OPEN: {
            const tracks = [...state.tracks];

            tracks[action.payload.parentTrackIndex].open = action.payload.state;
            return {
                ...state,
                tracks
            };
        }
        case GET_UI_STATE: {
            return {
                ...state,
                uiState: action.payload
            };
        }
        case SET_UI_STATE: {
            let uiState = { ...state.uiState };
            uiState[action.payload.key] = action.payload.value;
            return {
                ...state,
                uiState
            };
        }
        case SET_TRACK_HEIGHT: {
            const {
                parentTrackIndex,
                childTrackIndex,
                height
            } = action.payload;

            if (childTrackIndex === false) {
                state.tracks[parentTrackIndex].height = height;
            } else {
                state.tracks[parentTrackIndex].children[
                    childTrackIndex
                ].height = height;
            }
            return {
                ...state,
                tracks: [...state.tracks]
            };
        }
        case SET_WEEK_COUNT: {
            return {
                ...state,
                weekCount: action.payload
            };
        }
        case SET_AGENDA_ITEM_POSITION: {
            return {
                ...state,
                agendaItemPosition: action.payload
            };
        }
        case SET_AGENDA_ITEM_DRAGGING: {
            return {
                ...state,
                agendaItemDragging: action.payload
            };
        }
        case SET_CLICKED_TIME_BLOCK: {
            return {
                ...state,
                clickedDayTimeBlock: action.payload
            };
        }
        case SET_FOCUSSED_EVENT_INDICES: {
            return {
                ...state,
                focussedEventIndices: action.payload
            };
        }
        case SET_FOCUSSED_EVENT: {
            return {
                ...state,
                focussedEvent: action.payload.event,
                focussedEventHasFocus: action.payload.hasFocus
            };
        }
        case GET_JOB_PACKS: {
            return {
                ...state,
                jobpacks: action.payload
            };
        }
        case GET_USERS: {
            return {
                ...state,
                users: action.payload
            };
        }
        case GET_MACHINES: {
            return {
                ...state,
                machines: action.payload
            };
        }
        case GET_EQUIPMENT: {
            return {
                ...state,
                equipment: action.payload
            };
        }
        case SET_CREATE_CHILD_TRACK_PARENT: {
            return {
                ...state,
                createChildTrackParent: action.payload
            };
        }
        case SET_DELETING_TRACK: {
            return {
                ...state,
                deletingTrack: action.payload
            };
        }
        case SET_EDITING_TRACK: {
            const newState = {
                ...state,
                editingTrack: action.payload
            };

            return newState;
        }
        case DELETE_TRACK: {
            return {
                ...state,
                tracks: action.payload,
                deletingTrack: false
            };
        }
        case EDIT_TRACK: {
            return {
                ...state,
                tracks: action.payload,
                editingTrack: false
            };
        }
        case CREATE_PARENT_TRACK: {
            return {
                ...state,
                tracks: action.payload
            };
        }
        case CREATE_CHILD_TRACK: {
            return {
                ...state,
                tracks: action.payload
            };
        }
        case OPEN_ADD_CHILD_TRACK_MODAL: {
            return {
                ...state,
                showAddChildTrackModal: true
            };
        }
        case CLOSE_ADD_CHILD_TRACK_MODAL: {
            return {
                ...state,
                showAddChildTrackModal: false
            };
        }
        case OPEN_ADD_PARENT_TRACK_MODAL: {
            return {
                ...state,
                showAddParentTrackModal: true
            };
        }
        case CLOSE_ADD_PARENT_TRACK_MODAL: {
            return {
                ...state,
                showAddParentTrackModal: false
            };
        }
        case OPEN_EDIT_TRACK_MODAL: {
            return {
                ...state,
                showEditTrackModal: true
            };
        }
        case CLOSE_EDIT_TRACK_MODAL: {
            return {
                ...state,
                showEditTrackModal: false
            };
        }
        case OPEN_DELETE_TRACK_MODAL: {
            return {
                ...state,
                showDeleteTrackModal: true
            };
        }
        case CLOSE_DELETE_TRACK_MODAL: {
            return {
                ...state,
                showDeleteTrackModal: false,
                deletingTrack: false
            };
        }
        case OPEN_EDIT_EVENT_MODAL: {
            return {
                ...state,
                showEditEventModal: true
            };
        }
        case CLOSE_EDIT_EVENT_MODAL: {
            return {
                ...state,
                showEditEventModal: false
            };
        }
        case OPEN_ADD_EVENT_MODAL: {
            return {
                ...state,
                showAddEventModal: true,
                clickedTimeBlock: action.payload
            };
        }
        case CLOSE_ADD_EVENT_MODAL: {
            return {
                ...state,
                showAddEventModal: false,
                clickedTimeBlock: false
            };
        }

        case SET_TRACK_ROW: {
            return {
                ...state,
                tracks: action.payload
            };
        }
        case SET_DAY_RANGE: {
            return {
                ...state,
                start: action.payload.start,
                end: action.payload.end
            };
        }
        case SET_TRACKS: {
            return {
                ...state,
                tracks: action.payload
            };
        }

        case SET_SELECTED_DAYS: {
            return {
                ...state,
                selectedDays: action.payload
            };
        }
        default: {
            return state;
        }
    }
};

export default combineReducers({ MainReducer });
